// Texte der Dublettenansicht, des Zusammenführens, des Löschens und des Datenschutz-Bereichs (Agent 7C, Runde 7). Alles deutsch, die
// eingeführten Begriffe des CRM: Lead, Kontakt, Aktivität, Aufgabe, Opportunity. Bewusst in einer eigenen Datei, nicht in `texte.ts`.
import type { DublettenArt } from "../api/dubletten";

export const ART_TITEL: Record<Exclude<DublettenArt, "alle">, string> = {
  telefon: "Telefon",
  email: "E-Mail",
  domain: "Webseite",
  name: "Name",
};

export const ART_FILTER: { id: DublettenArt; titel: string }[] = [
  { id: "alle", titel: "Alle" },
  { id: "telefon", titel: "Telefon" },
  { id: "email", titel: "E-Mail" },
  { id: "domain", titel: "Webseite" },
  { id: "name", titel: "Name" },
];

export const TX = {
  seiteTitel: "Dubletten",
  seiteText:
    "Leads, die doppelt im CRM stehen: gleiche Telefonnummer, E-Mail-Adresse, Webseite oder gleicher Name. Das Zusammenführen gilt im CRM. In Close bleiben beide Leads bestehen, bis du dort ebenfalls zusammenführst; das CRM übernimmt das dann.",
  reiterGruppen: "Dubletten",
  reiterProtokoll: "Zusammengeführt",
  ignorierteZeigen: "Als „keine Dublette“ gemerkte zeigen",
  keineGruppen: "Keine Dubletten gefunden",
  keineGruppenText: "Es gibt keine Leads mit gleicher Nummer, Adresse, Webseite oder gleichem Namen, die nicht schon als „keine Dublette“ gemerkt sind.",
  keinProtokoll: "Noch nichts zusammengeführt",
  keinProtokollText: "Hier erscheinen alle Zusammenführungen, auch die, die Close selbst gemacht hat.",
  behalten: "Behalten",
  zusammenfuehren: "Zusammenführen …",
  keineDublette: "Keine Dublette",
  keineDubletteTitel: "Dieses Paar nicht mehr als Dublette zeigen",
  wiederZeigen: "Wieder zeigen",
  schwach: "Nur ein kurzer Name: oft Zufall",
  kundenakte: "Kundenakte",
  kundenakteTitel: "Dieser Lead hat eine Kundenakte im Backoffice. Besser als Ziel wählen.",
  weitere: (n: number) => `${n} weitere Leads in dieser Gruppe`,
  gemerkt: "Gemerkt als keine Dublette",
  ladeMehr: "Mehr laden",
  rueckgaengig: "Rückgängig",
  rueckgaengigFrage: "Zusammenführung rückgängig machen? Die Zeilen des Quell-Leads gehen zurück zu ihm.",
  ausClose: "aus Close übernommen",
  imCrm: "im CRM",
  zusammengefuehrt: "zusammengeführt",
  alsHinweis: "Mögliche Dubletten",
  keineHinweise: "Keine möglichen Dubletten gefunden.",

  // Zusammenführen
  zfTitel: "Leads zusammenführen",
  zfZiel: "Bleibt bestehen",
  zfQuelle: "Geht darin auf",
  zfTauschen: "Richtung tauschen",
  zfWandert: "Das wandert zum bestehenden Lead",
  zfFelder: "Felder",
  zfFelderText: "Leere Felder des bestehenden Leads werden aus dem anderen gefüllt, das ältere Anlagedatum bleibt.",
  zfGesperrt: "Zusammenführen nicht möglich: beide Leads haben eine Kundenakte.",
  zfAusfuehren: "Zusammenführen",
  zfFertig: "Zusammengeführt.",
  zfFertigClose: "Führe sie in Close ebenfalls zusammen, damit beide Seiten gleich sind.",
  zfLeadWaehlen: "Mit welchem Lead zusammenführen?",
  zfLeadSuche: "Lead suchen (Name, Nummer, E-Mail) …",
  zfRichtungFrage: "Welcher Lead bleibt bestehen?",
  zfDieser: "Dieser Lead bleibt",
  zfAnderer: "Der andere Lead bleibt",

  // Löschen
  loeschTitel: "Lead löschen",
  loeschWarnung:
    "Das Löschen ist endgültig. Der Lead verschwindet mit seinen Kontakten, Aktivitäten, Aufgaben, Opportunities, Anrufen, SMS, E-Mails und seinem Log aus dem CRM. Es gibt kein Rückgängig.",
  loeschClose:
    "Gelöscht wird nur im CRM. Close bleibt unverändert; dort musst du den Lead von Hand löschen. Bis dahin hält das CRM ihn aus dem Abgleich heraus.",
  loeschSicherung: "In älteren Sicherungen der Datenbank steht er noch, bis diese ablaufen.",
  loeschGrund: "Grund (wird protokolliert, ohne Namen)",
  loeschGrundPlatz: "z. B. Löschwunsch per E-Mail vom …",
  loeschName: (name: string) => `Zur Bestätigung den Namen eintippen: ${name}`,
  loeschKnopf: "Endgültig löschen",
  loeschGeloescht: "Lead gelöscht.",
  loeschKundenakte: "Dieser Lead hat eine Kundenakte und wird nicht gelöscht.",
  loeschZusammengefuehrt: "Dieser Lead ist in einem anderen aufgegangen. Lösche den Ziel-Lead; dieser geht dann mit.",
  loeschAuskunft: "Auskunft herunterladen",
  loeschAuskunftHinweis: "Die Auskunft ist eine JSON-Datei mit allen Daten zu diesem Lead.",
  loeschUmfang: (k: number, a: number, f: number) => `Mit dem Lead gehen ${k} ${k === 1 ? "Kontakt" : "Kontakte"}, ${a} ${a === 1 ? "Aktivität" : "Aktivitäten"} und ${f} offene ${f === 1 ? "Aufgabe" : "Aufgaben"}.`,

  // Menüpunkte im Lead
  menueZusammenfuehren: "Mit anderem Lead zusammenführen …",
  menueDubletten: (n: number) => `Mögliche Dubletten (${n})`,
  menueLoeschen: "Lead löschen …",
  menueAuskunft: "Auskunft über diesen Lead …",
  menueUeberschrift: "Dubletten und Datenschutz",
};

// Datenschutz-Seite
export const DS = {
  reiter: [
    { id: "widersprueche", titel: "Werbewidersprüche" },
    { id: "leads", titel: "Auskunft und Löschen" },
    { id: "fristen", titel: "Löschfristen" },
    { id: "protokoll", titel: "Löschprotokoll" },
  ] as const,
  fristenText:
    "Mit eingeschalteten Fristen löscht das CRM von allein, was lange liegt. Das Löschen ist endgültig und gilt nur im CRM. Nie gelöscht werden Leads mit Kundenakte, mit offenen Aufgaben oder Opportunities, im Status Blacklist oder mit Aktivität innerhalb der Frist. Höchstens 25 Leads je Lauf, einmal am Tag.",
  fristenAktiv: "Löschfristen einschalten",
  fristenAktivHinweis: "Aus, bis du sie bewusst einschaltest.",
  fristenLead: "Leads ohne Aktivität löschen nach",
  fristenLeadAus: "nie",
  fristenGeloescht: "In Close gelöschte Leads aus dem CRM entfernen nach",
  fristenProtokoll: "Auskünfte und Fristläufe im Löschprotokoll aufbewahren",
  fristenProtokollHinweis: "Die Zeilen zu gelöschten Leads und Personen bleiben (ohne Grund und Nutzer), damit der Abgleich sie nicht zurückholt.",
  tage: "Tage",
  monate: "Monate",
  jahre: "Jahre",
  vorschauTitel: "Das träfe der nächste Lauf",
  vorschauLeads: (n: number) => `${n} ${n === 1 ? "Lead" : "Leads"} ohne Aktivität`,
  vorschauGeloescht: (n: number) => `${n} in Close gelöschte ${n === 1 ? "Lead" : "Leads"}`,
  vorschauProtokoll: (n: number) => `${n} alte ${n === 1 ? "Protokollzeile" : "Protokollzeilen"}`,
  vorschauNichts: "Nichts.",
  gespeichert: "Fristen gespeichert.",
  einschaltenFrage:
    "Löschfristen einschalten? Ab dem nächsten Lauf werden Leads endgültig gelöscht, auf die die Fristen zutreffen (siehe Vorschau).",

  leadsText:
    "Auskunft über die Daten eines Leads erstellen oder den Lead mit allem, was an ihm hängt, endgültig löschen. Personen löschst du unten einzeln.",
  leadsSuche: "Lead suchen (Name, Nummer, E-Mail) …",
  personenTitel: "Person löschen",
  personenText: "Löscht einen Kontakt mit seinen Anrufen, SMS, E-Mails und Aufgaben. Der Lead und seine übrigen Daten bleiben.",
  personLoeschen: "Person löschen …",
  personFrage: (name: string) => `${name} löschen`,
  personGrund: "Grund (wird protokolliert, ohne Namen)",
  personKnopf: "Person endgültig löschen",
  personGeloescht: "Person gelöscht.",
  keineKontakte: "Dieser Lead hat keine Kontakte.",

  widerspruecheText:
    "Wer nicht mehr beworben werden will, steht hier. Gesperrte Adressen, Domains und Nummern bekommen keine E-Mail (auch keine Massen-Mail und keine Workflow-Mail), keine SMS und stehen nicht im Power Dialer. Aufgehoben wird nur hier.",
  widerspruchNeu: "Widerspruch erfassen",
  widerspruchArt: "Art",
  widerspruchWert: "Adresse, Domain oder Nummer",
  widerspruchKanal: "Gilt für",
  widerspruchGrund: "Grund oder Quelle (nur für uns)",
  widerspruchHerkunft: "Eingegangen per",
  widerspruchSperren: "Sperren",
  widerspruchErfasst: "Gesperrt.",
  widerspruchSchonDa: "Das war schon gesperrt.",
  widerspruchAufheben: "Aufheben",
  widerspruchAufgehoben: "Sperre aufgehoben.",
  widerspruchAufhebenFrage: "Sperre aufheben? Danach darf an diese Adresse oder Nummer wieder geschrieben werden.",
  aufgehobeneZeigen: "Aufgehobene zeigen",
  keineWidersprueche: "Keine Sperren eingetragen.",
  suche: "Suchen …",
  gesperrteNummern: "Rufnummern, bei denen eingehende Anrufe abgewiesen werden, stehen unter Einstellungen › Nummern.",

  protokollText:
    "Wer wann was gelöscht oder ausgewertet hat. Das Protokoll enthält keine Personendaten: nur die ID, Zählungen und den Grund.",
  keinProtokoll: "Noch nichts protokolliert.",
};

export const KANAL_TITEL: Record<string, string> = { alle: "Alle Wege", email: "E-Mail", telefon: "Telefon", sms: "SMS" };
export const HERKUNFT_TITEL: Record<string, string> = {
  mail: "E-Mail",
  telefon: "Telefon",
  brief: "Brief",
  formular: "Formular",
  abmeldelink: "Abmeldelink",
};
export const PROTOKOLL_ART_TITEL: Record<string, string> = {
  lead_loeschen: "Lead gelöscht",
  person_loeschen: "Person gelöscht",
  auskunft: "Auskunft erstellt",
  frist: "Löschfristen angewendet",
};
export const UMFANG_TITEL: Record<string, string> = {
  leads: "Leads",
  kontakte: "Kontakte",
  aktivitaeten: "Aktivitäten",
  aufgaben: "Aufgaben",
  opportunities: "Opportunities",
  anrufe: "Anrufe",
  sms: "SMS",
  mails: "E-Mails",
  entwuerfe: "Entwürfe",
  angeheftet: "Angeheftete Notizen",
  benachrichtigungen: "Erwähnungen",
  workflow_laeufe: "Workflow-Läufe",
  log: "Log-Einträge",
  eingang: "Eingangsprotokoll",
  widersprueche: "Widersprüche",
  widersprueche_bleiben: "Sperreinträge bleiben",
  dateien: "Dateien",
  ereignisse_bereinigt: "Ereignisse bereinigt",
  felder: "Felder",
  leads_ohne_aktivitaet: "Leads ohne Aktivität",
  in_close_geloeschte: "In Close gelöschte Leads",
  protokoll_bereinigt: "Protokollzeilen bereinigt",
  fehler: "Fehler",
  zusammen_mit: "zusammen mit",
};

const EINZAHL: Record<string, string> = {
  leads: "Lead",
  kontakte: "Kontakt",
  aktivitaeten: "Aktivität",
  aufgaben: "Aufgabe",
  opportunities: "Opportunity",
  anrufe: "Anruf",
  mails: "E-Mail",
  entwuerfe: "Entwurf",
  dateien: "Datei",
  felder: "Feld",
  log: "Log-Eintrag",
};

export function umfangText(umfang: Record<string, unknown> | undefined): string {
  if (!umfang) return "";
  const teile: string[] = [];
  for (const [k, v] of Object.entries(umfang)) {
    if (typeof v !== "number" || v === 0) continue;
    teile.push(`${v} ${v === 1 && EINZAHL[k] ? EINZAHL[k] : (UMFANG_TITEL[k] ?? k)}`);
  }
  return teile.join(" · ");
}
